import { render, staticRenderFns } from "./forgot-username.vue?vue&type=template&id=fa4c142e"
import script from "./forgot-username.vue?vue&type=script&lang=js"
export * from "./forgot-username.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports